export default __webpack_public_path__ + "static/media/coupons-placeholder.ce98b1fd.jpg";